import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {UtilService} from '../../services/util.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  standalone: false
})

export class PrivacyPolicyComponent implements OnInit {
  private _destroyRef: DestroyRef = inject(DestroyRef);
  private _utilService: UtilService = inject(UtilService);

  public content: string = '';

  public ngOnInit(): void {
    this._utilService.getPrivacyPolicy()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result) => {
        this.content = result;
      });
  }
}
